import { useCallback } from "react";

import { createFiltersFromFilterData } from "../../../../utils/formViews";

import { Filter, ComplexFilter } from "../../../common/hooks/useLocalTable";
import useEntityFormViewTable from "../../../common/hooks/useEntityFormViewTable";

const getFilters = (searchString, filterData) => {
    const filters = [];

    if (searchString) {
        filters.push(
            new ComplexFilter([new Filter("description", Filter.CO, searchString), new Filter("roleName", Filter.CO, searchString)], ComplexFilter.OR)
        );
    }

    if (filterData) {
        const createdFilters = createFiltersFromFilterData(filterData);
        filters.push(...createdFilters);
    }
    return filters;
};

const useCriticalRolesTable = (roles) => {
    const getDialogFilters = useCallback(
        async ({ field, search = "" }) => {
            const lowerSearch = search.toLowerCase();
            let keys;

            switch (field) {
                case "roleName": {
                    keys = roles.filter(({ roleName }) => roleName?.toLowerCase().includes(lowerSearch)).map(({ roleName }) => roleName);
                    break;
                }
                case "system": {
                    keys = roles.filter(({ system }) => system?.toLowerCase().includes(lowerSearch)).map(({ system }) => system);
                    break;
                }
            }

            const uniqueKeys = [...new Set(keys)];
            const rows = uniqueKeys.map((key) => ({ key, text: key }));
            return { rows, total: rows?.length };
        },
        [roles]
    );

    const viewTable = useEntityFormViewTable(roles, getFilters);

    return {
        ...viewTable,
        getDialogFilters,
    };
};

export default useCriticalRolesTable;
